import React, { Component } from "react";
import ICON from "../icons.js";

/* ============================================================================
 * HomeImage — รูปที่มีภาพสำรองในตัว
 *
 * ★ ทำไมต้องมีคอมโพเนนต์นี้ ไม่ใช้ <img> ตรง ๆ
 *   ลิงก์รูปที่เก็บใน DB อาจเสีย (ไฟล์ถูกลบ / URL เก่า / S3 ตอบ 403)
 *   <img> ที่โหลดไม่ขึ้นจะโชว์ไอคอนรูปแตกของเบราว์เซอร์ทับข้อความ alt
 *   ซึ่งดูเหมือนหน้าเว็บพัง — แย่กว่าไม่มีรูปเลย
 *   ตัวนี้ดักตอนโหลดไม่สำเร็จแล้วสลับไปเป็นไอคอนบนพื้นอ่อนแทน
 *
 * ไม่มี src มาตั้งแต่แรกก็ขึ้นภาพสำรองเหมือนกัน ผู้เรียกจึงไม่ต้องเช็คเอง
 * ========================================================================== */
export default class HomeImage extends Component {
    state = { failed: false };

    componentDidUpdate(prevProps) {
        // เปลี่ยนรูป (เช่นกดสลับรูปย่อย) ต้องลองโหลดใหม่ ไม่ใช่ค้างภาพสำรองไว้
        if (prevProps.src !== this.props.src && this.state.failed) this.setState({ failed: false });
    }

    render() {
        // eager = รูปที่อยู่บนจอแรก (เช่นรูปเด่นของแกลเลอรี) ไม่ต้องรอ lazy
        const { src, alt, icon, className, eager } = this.props;
        const { failed } = this.state;

        if (!src || failed) {
            return (
                <div className={`hm-img-fallback ${className || ""}`} aria-label={alt} role="img">
                    <span className="hm-ico">{icon || ICON.image}</span>
                </div>
            );
        }

        return (
            <img
                src={src}
                alt={alt || ""}
                className={className}
                // ★ lazy : หน้ารวมมีการ์ดหลายสิบใบ เดิมโหลดรูปทุกใบพร้อมกันตั้งแต่เปิดหน้า
                //   decoding async : ถอดรหัสรูปนอก main thread เลื่อนหน้าไม่กระตุก
                loading={eager ? "eager" : "lazy"}
                decoding="async"
                onError={() => this.setState({ failed: true })}
            />
        );
    }
}
